(() => {
  const selector = 'boiler-product-details';

  class BoilerProductDetails extends HTMLElement {
    connectedCallback() {
      if (this.dataset.boilerProductReady === 'true') return;
      this.dataset.boilerProductReady = 'true';
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.activateTab(tab));
        tab.addEventListener('keydown', (event) => this.onKeydown(event));
      });
      this.querySelectorAll('[data-boiler-product-dialog-open]').forEach((button) => {
        button.addEventListener('click', () => this.openDialog(button));
      });
      this.querySelectorAll('.boiler-product-dialog').forEach((dialog) => {
        dialog.querySelector('[data-boiler-product-dialog-close]')?.addEventListener('click', () => dialog.close());
        dialog.addEventListener('click', (event) => {
          if (event.target === dialog) dialog.close();
        });
      });
      this.querySelectorAll('[data-boiler-product-slider]').forEach((slider) => this.initSlider(slider));
    }

    activateTab(nextTab, moveFocus = false) {
      this.tabs.forEach((tab) => {
        const active = tab === nextTab;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
      });
      this.panels.forEach((panel) => {
        panel.hidden = panel.id !== nextTab.getAttribute('aria-controls');
      });
      if (moveFocus) nextTab.focus();
    }

    onKeydown(event) {
      const currentIndex = this.tabs.indexOf(event.currentTarget);
      let nextIndex = currentIndex;
      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (currentIndex + 1) % this.tabs.length;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = this.tabs.length - 1;
      if (nextIndex === currentIndex) return;
      event.preventDefault();
      this.activateTab(this.tabs[nextIndex], true);
    }

    openDialog(button) {
      const dialog = this.querySelector(`#${button.dataset.boilerProductDialogOpen}`);
      if (!dialog) return;
      this.dialogOpener = button;
      dialog.showModal();
      dialog.addEventListener('close', () => this.dialogOpener?.focus(), { once: true });
    }

    initSlider(slider) {
      const viewport = slider.querySelector('[data-boiler-product-slider-viewport]');
      const previous = slider.querySelector('[data-boiler-product-slider-prev]');
      const next = slider.querySelector('[data-boiler-product-slider-next]');
      if (!viewport || !previous || !next) return;

      const updateControls = () => {
        const maxScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
        previous.disabled = viewport.scrollLeft <= 2;
        next.disabled = viewport.scrollLeft >= maxScroll - 2;
      };

      const move = (direction) => {
        const firstCard = viewport.querySelector('.boiler-product-related-card');
        const track = viewport.querySelector('.boiler-product-related-track');
        const gap = track ? Number.parseFloat(getComputedStyle(track).columnGap) || 0 : 0;
        const step = firstCard ? firstCard.getBoundingClientRect().width + gap : viewport.clientWidth * 0.8;
        viewport.scrollBy({ left: direction * step, behavior: 'smooth' });
      };

      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      viewport.addEventListener('scroll', updateControls, { passive: true });
      window.addEventListener('resize', updateControls, { passive: true });
      requestAnimationFrame(updateControls);
    }
  }

  if (!customElements.get(selector)) customElements.define(selector, BoilerProductDetails);

  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:block:select', (event) => {
      const section = event.target.closest(selector);
      if (!section) return;
      const panelName = event.target.dataset.boilerProductPanel;
      const tab = panelName && section.querySelector(`[role="tab"][data-boiler-product-tab="${panelName}"]`);
      if (tab) section.activateTab(tab);
    });
  }
})();
